import api from "@/services/api";

const state = {
  list: [],
};

const mutations = {
  SET_DEBIT_NOTES(state, debitNotes) {
    state.list = debitNotes;
  },
};

const actions = {
  // ================= CREATE =================
  async createDebitNote(_, payload) {
    try {
      const res = await api.post("/debit-notes", payload);
      return res.data;
    } catch (error) {
      console.error("Error creating debit note:", error.message);
      throw error;
    }
  },

  // ================= GET ALL =================
  async getDebitNotes({ commit }) {
    try {
      const res = await api.get("/debit-notes");
      commit("SET_DEBIT_NOTES", res.data);
    } catch (error) {
      console.error("Error fetching debit notes:", error.message);
      throw error;
    }
  },

  // ================= GET BY ID =================
  async getDebitNoteById(_, id) {
    try {
      const res = await api.get(`/debit-notes/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching debit note:", error.message);
      throw error;
    }
  },

  // ================= UPDATE =================
  async updateDebitNote(_, payload) {
    try {
      const id = payload.id;
      const res = await api.put(`/debit-notes/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating debit note:", error.message);
      throw error;
    }
  },

  // ================= CANCEL =================
  async cancelDebitNote(_, id) {
    try {
      const res = await api.put(`/debit-notes/${id}/cancel`);
      return res.data;
    } catch (error) {
      console.error("Error cancelling debit note:", error.message);
      throw error;
    }
  },

  // ================= RECORD REFUND =================
  async recordRefund(_, { id, paymentMethod, note }) {
    try {
      const res = await api.put(`/debit-notes/${id}/refund`, { paymentMethod, note });
      return res.data;
    } catch (error) {
      console.error("Error recording refund:", error.message);
      throw error;
    }
  },

  // ================= DELETE =================
  async deleteDebitNote(_, id) {
    try {
      const res = await api.delete(`/debit-notes/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting debit note:", error.message);
      throw error;
    }
  },

  // ================= NEXT NUMBER =================
  async getNextDebitNoteNumber() {
    try {
      const res = await api.get("/debit-notes/next-debit-note-number");
      return res.data.nextDebitNoteNumber;
    } catch (error) {
      console.error("Error fetching next debit note number:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
